<template>

    <div class="shop::category-selector">

        <div class="text-gray-600 mb-1 label" v-if="label">{{ label }}</div>

        <treeselect
            ref="treeselect"
            :options="treeOptions"
            :name="name"
            v-model="internalValue"
            clearAllText="Verwijder allemaal"
            clearValueText="Verwijder"
            loadingText="Laden..."
            noChildrenText="Geen categorieën"
            noOptionsText="Geen keuzes..."
            noResultsText="Geen keuzes..."
            placeholder="Kies categorie..."
            retryText="Probeer opnieuw"
            searchPromptText="Typ om te zoeken"
            :closeOnSelect="true"
            :multiple="false"
            search-nested
        >

            <template slot="option-label" slot-scope="{ node }">

                <div
                    class="text-sm"
                    :class="{
                    'py-1': true,
                }"
                >
                    {{ node.raw.label }}
                </div>

            </template>

            <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>

        </treeselect>

    </div>

</template>

<script>

import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {

    components: {
        Treeselect,
    },

    props: {
        name: String,
        value: String,
        label: String,
    },

    data() {
        return {
            internalValue: null,
            categories: null,
        };
    },

    async mounted()
    {
        this.internalValue = this.value;

        await this.loadData();
    },

    methods: {

        async loadData() {
            // Load artists.
            this.categories = (await axios.get('/admin/modules/shop/categories/get-tree')).data;
        },

        mapItem(category, children) {
            // Abort due to no items? Otherwise Treeselect will show empty subtree.
            if (!children.length)
                return undefined;

            return _.map(children, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: support search & multi language.
                    children: this.mapItem( category, category.children ),
                };
            });
        },

    },

    computed: {

        treeOptions() {

            // Abort due to empty?
            if (this.categories === null)
                return [];

            // Map website pages.
            return _.map(this.categories, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: Add language support?
                    children: this.mapItem(category, category.children),
                };
            });
        },

    }

}

</script>

<style lang="scss">

// TODO High: Review, make it consistent with other elements in Galaxy. Why did we need so many custom CSS?
.shop\:\:category-selector {

    .vue-treeselect__control {
        @apply border border-gray-300 outline-none shadow-none flex items-center relative px-3 py-2 leading-normal;
        height: auto;
    }

    .vue-treeselect__input {
        &:focus {
            box-shadow: none;
        }
    }

    .vue-treeselect__placeholder, .vue-treeselect__single-value {
        line-height: 1.3em;
    }

    .vue-treeselect__list {
        .vue-treeselect__option {
            @apply flex items-center px-5 py-2;
        }

        .vue-treeselect__list {
            @apply pl-5;
        }
    }

}

</style>
